/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthErrorRouteImport } from './routes/auth-error'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InvitesTokenRouteImport } from './routes/invites.$token'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppOrgRouteRouteImport } from './routes/_app/org/route'
import { Route as AppAdminRouteRouteImport } from './routes/_app/admin/route'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppPackagesIndexRouteImport } from './routes/_app/packages/index'
import { Route as AppOrgIndexRouteImport } from './routes/_app/org/index'
import { Route as AppSettingsTokensRouteImport } from './routes/_app/settings/tokens'
import { Route as AppSettingsSecurityRouteImport } from './routes/_app/settings/security'
import { Route as AppPackagesRepoRouteImport } from './routes/_app/packages/$repo'
import { Route as AppOrgRequestsRouteImport } from './routes/_app/org/requests'
import { Route as AppOrgInvitesRouteImport } from './routes/_app/org/invites'
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin/settings'
import { Route as AppAdminOrganizationsRouteImport } from './routes/_app/admin/organizations'
import { Route as AppOrgSecurityIndexRouteImport } from './routes/_app/org/security/index'
import { Route as AppOrgRepositoriesIndexRouteImport } from './routes/_app/org/repositories/index'
import { Route as AppOrgPoliciesIndexRouteImport } from './routes/_app/org/policies/index'
import { Route as AppOrgAuditIndexRouteImport } from './routes/_app/org/audit/index'
import { Route as AppAdminAuditIndexRouteImport } from './routes/_app/admin/audit/index'
import { Route as AppOrgPoliciesNewRouteImport } from './routes/_app/org/policies/new'
import { Route as AppOrgPoliciesIdRouteImport } from './routes/_app/org/policies/$id'
import { Route as AppAdminAuditMirrorsRouteImport } from './routes/_app/admin/audit/mirrors'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth-error',
  path: '/auth-error',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitesTokenRoute = InvitesTokenRouteImport.update({
  id: '/invites/$token',
  path: '/invites/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgRouteRoute = AppOrgRouteRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRoute,
} as any)
const AppPackagesIndexRoute = AppPackagesIndexRouteImport.update({
  id: '/packages/',
  path: '/packages/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgIndexRoute = AppOrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppSettingsTokensRoute = AppSettingsTokensRouteImport.update({
  id: '/settings/tokens',
  path: '/settings/tokens',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/settings/security',
  path: '/settings/security',
  getParentRoute: () => AppRoute,
} as any)
const AppPackagesRepoRoute = AppPackagesRepoRouteImport.update({
  id: '/packages/$repo',
  path: '/packages/$repo',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgRequestsRoute = AppOrgRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppOrgInvitesRoute = AppOrgInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOrganizationsRoute = AppAdminOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppOrgSecurityIndexRoute = AppOrgSecurityIndexRouteImport.update({
  id: '/security/',
  path: '/security/',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppOrgRepositoriesIndexRoute = AppOrgRepositoriesIndexRouteImport.update({
  id: '/repositories/',
  path: '/repositories/',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppOrgPoliciesIndexRoute = AppOrgPoliciesIndexRouteImport.update({
  id: '/policies/',
  path: '/policies/',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppOrgAuditIndexRoute = AppOrgAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppAdminAuditIndexRoute = AppAdminAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppOrgPoliciesNewRoute = AppOrgPoliciesNewRouteImport.update({
  id: '/policies/new',
  path: '/policies/new',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppOrgPoliciesIdRoute = AppOrgPoliciesIdRouteImport.update({
  id: '/policies/$id',
  path: '/policies/$id',
  getParentRoute: () => AppOrgRouteRoute,
} as any)
const AppAdminAuditMirrorsRoute = AppAdminAuditMirrorsRouteImport.update({
  id: '/audit/mirrors',
  path: '/audit/mirrors',
  getParentRoute: () => AppAdminRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/org': typeof AppOrgRouteRouteWithChildren
  '/dashboard': typeof AppDashboardRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/admin/organizations': typeof AppAdminOrganizationsRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/org/invites': typeof AppOrgInvitesRoute
  '/org/requests': typeof AppOrgRequestsRoute
  '/packages/$repo': typeof AppPackagesRepoRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tokens': typeof AppSettingsTokensRoute
  '/org/': typeof AppOrgIndexRoute
  '/packages/': typeof AppPackagesIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/admin/audit/mirrors': typeof AppAdminAuditMirrorsRoute
  '/org/policies/$id': typeof AppOrgPoliciesIdRoute
  '/org/policies/new': typeof AppOrgPoliciesNewRoute
  '/admin/audit/': typeof AppAdminAuditIndexRoute
  '/org/audit/': typeof AppOrgAuditIndexRoute
  '/org/policies/': typeof AppOrgPoliciesIndexRoute
  '/org/repositories/': typeof AppOrgRepositoriesIndexRoute
  '/org/security/': typeof AppOrgSecurityIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/dashboard': typeof AppDashboardRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/admin/organizations': typeof AppAdminOrganizationsRoute
  '/admin/settings': typeof AppAdminSettingsRoute
  '/org/invites': typeof AppOrgInvitesRoute
  '/org/requests': typeof AppOrgRequestsRoute
  '/packages/$repo': typeof AppPackagesRepoRoute
  '/settings/security': typeof AppSettingsSecurityRoute
  '/settings/tokens': typeof AppSettingsTokensRoute
  '/org': typeof AppOrgIndexRoute
  '/packages': typeof AppPackagesIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/admin/audit/mirrors': typeof AppAdminAuditMirrorsRoute
  '/org/policies/$id': typeof AppOrgPoliciesIdRoute
  '/org/policies/new': typeof AppOrgPoliciesNewRoute
  '/admin/audit': typeof AppAdminAuditIndexRoute
  '/org/audit': typeof AppOrgAuditIndexRoute
  '/org/policies': typeof AppOrgPoliciesIndexRoute
  '/org/repositories': typeof AppOrgRepositoriesIndexRoute
  '/org/security': typeof AppOrgSecurityIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/_app/admin': typeof AppAdminRouteRouteWithChildren
  '/_app/org': typeof AppOrgRouteRouteWithChildren
  '/_app/dashboard': typeof AppDashboardRoute
  '/invites/$token': typeof InvitesTokenRoute
  '/_app/admin/organizations': typeof AppAdminOrganizationsRoute
  '/_app/admin/settings': typeof AppAdminSettingsRoute
  '/_app/org/invites': typeof AppOrgInvitesRoute
  '/_app/org/requests': typeof AppOrgRequestsRoute
  '/_app/packages/$repo': typeof AppPackagesRepoRoute
  '/_app/settings/security': typeof AppSettingsSecurityRoute
  '/_app/settings/tokens': typeof AppSettingsTokensRoute
  '/_app/org/': typeof AppOrgIndexRoute
  '/_app/packages/': typeof AppPackagesIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/admin/audit/mirrors': typeof AppAdminAuditMirrorsRoute
  '/_app/org/policies/$id': typeof AppOrgPoliciesIdRoute
  '/_app/org/policies/new': typeof AppOrgPoliciesNewRoute
  '/_app/admin/audit/': typeof AppAdminAuditIndexRoute
  '/_app/org/audit/': typeof AppOrgAuditIndexRoute
  '/_app/org/policies/': typeof AppOrgPoliciesIndexRoute
  '/_app/org/repositories/': typeof AppOrgRepositoriesIndexRoute
  '/_app/org/security/': typeof AppOrgSecurityIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth-error'
    | '/login'
    | '/onboarding'
    | '/admin'
    | '/org'
    | '/dashboard'
    | '/invites/$token'
    | '/admin/organizations'
    | '/admin/settings'
    | '/org/invites'
    | '/org/requests'
    | '/packages/$repo'
    | '/settings/security'
    | '/settings/tokens'
    | '/org/'
    | '/packages/'
    | '/settings/'
    | '/admin/audit/mirrors'
    | '/org/policies/$id'
    | '/org/policies/new'
    | '/admin/audit/'
    | '/org/audit/'
    | '/org/policies/'
    | '/org/repositories/'
    | '/org/security/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth-error'
    | '/login'
    | '/onboarding'
    | '/admin'
    | '/dashboard'
    | '/invites/$token'
    | '/admin/organizations'
    | '/admin/settings'
    | '/org/invites'
    | '/org/requests'
    | '/packages/$repo'
    | '/settings/security'
    | '/settings/tokens'
    | '/org'
    | '/packages'
    | '/settings'
    | '/admin/audit/mirrors'
    | '/org/policies/$id'
    | '/org/policies/new'
    | '/admin/audit'
    | '/org/audit'
    | '/org/policies'
    | '/org/repositories'
    | '/org/security'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/auth-error'
    | '/login'
    | '/onboarding'
    | '/_app/admin'
    | '/_app/org'
    | '/_app/dashboard'
    | '/invites/$token'
    | '/_app/admin/organizations'
    | '/_app/admin/settings'
    | '/_app/org/invites'
    | '/_app/org/requests'
    | '/_app/packages/$repo'
    | '/_app/settings/security'
    | '/_app/settings/tokens'
    | '/_app/org/'
    | '/_app/packages/'
    | '/_app/settings/'
    | '/_app/admin/audit/mirrors'
    | '/_app/org/policies/$id'
    | '/_app/org/policies/new'
    | '/_app/admin/audit/'
    | '/_app/org/audit/'
    | '/_app/org/policies/'
    | '/_app/org/repositories/'
    | '/_app/org/security/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthErrorRoute: typeof AuthErrorRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  InvitesTokenRoute: typeof InvitesTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-error': {
      id: '/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invites/$token': {
      id: '/invites/$token'
      path: '/invites/$token'
      fullPath: '/invites/$token'
      preLoaderRoute: typeof InvitesTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org': {
      id: '/_app/org'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof AppOrgRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/packages/': {
      id: '/_app/packages/'
      path: '/packages'
      fullPath: '/packages/'
      preLoaderRoute: typeof AppPackagesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/': {
      id: '/_app/org/'
      path: '/'
      fullPath: '/org/'
      preLoaderRoute: typeof AppOrgIndexRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/settings/tokens': {
      id: '/_app/settings/tokens'
      path: '/settings/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof AppSettingsTokensRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/security': {
      id: '/_app/settings/security'
      path: '/settings/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/packages/$repo': {
      id: '/_app/packages/$repo'
      path: '/packages/$repo'
      fullPath: '/packages/$repo'
      preLoaderRoute: typeof AppPackagesRepoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org/requests': {
      id: '/_app/org/requests'
      path: '/requests'
      fullPath: '/org/requests'
      preLoaderRoute: typeof AppOrgRequestsRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/org/invites': {
      id: '/_app/org/invites'
      path: '/invites'
      fullPath: '/org/invites'
      preLoaderRoute: typeof AppOrgInvitesRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/admin/settings': {
      id: '/_app/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AppAdminSettingsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organizations': {
      id: '/_app/admin/organizations'
      path: '/organizations'
      fullPath: '/admin/organizations'
      preLoaderRoute: typeof AppAdminOrganizationsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/org/security/': {
      id: '/_app/org/security/'
      path: '/security'
      fullPath: '/org/security/'
      preLoaderRoute: typeof AppOrgSecurityIndexRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/org/repositories/': {
      id: '/_app/org/repositories/'
      path: '/repositories'
      fullPath: '/org/repositories/'
      preLoaderRoute: typeof AppOrgRepositoriesIndexRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/org/policies/': {
      id: '/_app/org/policies/'
      path: '/policies'
      fullPath: '/org/policies/'
      preLoaderRoute: typeof AppOrgPoliciesIndexRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/org/audit/': {
      id: '/_app/org/audit/'
      path: '/audit'
      fullPath: '/org/audit/'
      preLoaderRoute: typeof AppOrgAuditIndexRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/admin/audit/': {
      id: '/_app/admin/audit/'
      path: '/audit'
      fullPath: '/admin/audit/'
      preLoaderRoute: typeof AppAdminAuditIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/org/policies/new': {
      id: '/_app/org/policies/new'
      path: '/policies/new'
      fullPath: '/org/policies/new'
      preLoaderRoute: typeof AppOrgPoliciesNewRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/org/policies/$id': {
      id: '/_app/org/policies/$id'
      path: '/policies/$id'
      fullPath: '/org/policies/$id'
      preLoaderRoute: typeof AppOrgPoliciesIdRouteImport
      parentRoute: typeof AppOrgRouteRoute
    }
    '/_app/admin/audit/mirrors': {
      id: '/_app/admin/audit/mirrors'
      path: '/audit/mirrors'
      fullPath: '/admin/audit/mirrors'
      preLoaderRoute: typeof AppAdminAuditMirrorsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
  }
}

interface AppAdminRouteRouteChildren {
  AppAdminOrganizationsRoute: typeof AppAdminOrganizationsRoute
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute
  AppAdminAuditMirrorsRoute: typeof AppAdminAuditMirrorsRoute
  AppAdminAuditIndexRoute: typeof AppAdminAuditIndexRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminOrganizationsRoute: AppAdminOrganizationsRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminAuditMirrorsRoute: AppAdminAuditMirrorsRoute,
  AppAdminAuditIndexRoute: AppAdminAuditIndexRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppOrgRouteRouteChildren {
  AppOrgInvitesRoute: typeof AppOrgInvitesRoute
  AppOrgRequestsRoute: typeof AppOrgRequestsRoute
  AppOrgIndexRoute: typeof AppOrgIndexRoute
  AppOrgPoliciesIdRoute: typeof AppOrgPoliciesIdRoute
  AppOrgPoliciesNewRoute: typeof AppOrgPoliciesNewRoute
  AppOrgAuditIndexRoute: typeof AppOrgAuditIndexRoute
  AppOrgPoliciesIndexRoute: typeof AppOrgPoliciesIndexRoute
  AppOrgRepositoriesIndexRoute: typeof AppOrgRepositoriesIndexRoute
  AppOrgSecurityIndexRoute: typeof AppOrgSecurityIndexRoute
}

const AppOrgRouteRouteChildren: AppOrgRouteRouteChildren = {
  AppOrgInvitesRoute: AppOrgInvitesRoute,
  AppOrgRequestsRoute: AppOrgRequestsRoute,
  AppOrgIndexRoute: AppOrgIndexRoute,
  AppOrgPoliciesIdRoute: AppOrgPoliciesIdRoute,
  AppOrgPoliciesNewRoute: AppOrgPoliciesNewRoute,
  AppOrgAuditIndexRoute: AppOrgAuditIndexRoute,
  AppOrgPoliciesIndexRoute: AppOrgPoliciesIndexRoute,
  AppOrgRepositoriesIndexRoute: AppOrgRepositoriesIndexRoute,
  AppOrgSecurityIndexRoute: AppOrgSecurityIndexRoute,
}

const AppOrgRouteRouteWithChildren = AppOrgRouteRoute._addFileChildren(
  AppOrgRouteRouteChildren,
)

interface AppRouteChildren {
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppOrgRouteRoute: typeof AppOrgRouteRouteWithChildren
  AppDashboardRoute: typeof AppDashboardRoute
  AppPackagesRepoRoute: typeof AppPackagesRepoRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTokensRoute: typeof AppSettingsTokensRoute
  AppPackagesIndexRoute: typeof AppPackagesIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppOrgRouteRoute: AppOrgRouteRouteWithChildren,
  AppDashboardRoute: AppDashboardRoute,
  AppPackagesRepoRoute: AppPackagesRepoRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTokensRoute: AppSettingsTokensRoute,
  AppPackagesIndexRoute: AppPackagesIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthErrorRoute: AuthErrorRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  InvitesTokenRoute: InvitesTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
